import object from 'helpers/object'


export const initialState = {
  isUserLinking: false,
  isRequestLoaderVisible: false,
  closedPopups: {},
  text: null,
  icons: [],
  weather: {},
  chat: {},
  pressure: {
    title: '',
    units: '',
    value: '',
    isFetching: true,
  },
  humidity: {
    title: '',
    units: '',
    value: '',
    isFetching: true,
  },
  radiation: {
    title: '',
    units: '',
    value: '',
    isFetching: true,
  },
  waterLevel: {
    title: '',
    units: '',
    value: '',
    isFetching: true,
  },
  lightning: {
    title: '',
    units: '',
    value: '',
    isFetching: true,
  },
  weatherCode: '',
}

export const setUserLinking = (state, payload) => {
  return {
    ...state,
    isRequestLoaderVisible: payload,
    isUserLinking: payload,
  }
}

export const setIcons = (state, payload) => (
  object.setIn(state, 'icons', payload)
)

export const setWeather = (state, payload) => (
  object.setIn(state, 'weather', payload)
)

export const setChat = (state, payload) => (
  object.setIn(state, 'chat', payload)
)

export const setRequestLoaderVisibility = (state, payload) => {
  return {
    ...state,
    text: payload.text,
    isRequestLoaderVisible: payload.show,
  }
}

export const setPressure = (state, payload) => (
  object.setIn(state, 'pressure', payload)
)

export const setHumidity = (state, payload) => (
  object.setIn(state, 'humidity', payload)
)

export const setRadiation = (state, payload) => (
  object.setIn(state, 'radiation', payload)
)

export const setWaterLevel = (state, payload) => (
  object.setIn(state, 'waterLevel', payload)
)

export const setLightning = (state, payload) => (
  object.setIn(state, 'lightning', payload)
)

export const setWeatherCode = (state, payload) => (
  object.setIn(state, 'weatherCode', payload)
)

export const setClosedPopups = (state, payload) => {
  return {
    ...state,
    closedPopups: payload,
  }
}
